<template>
  <div class="clearfix">
    <div class="topMain">
      <div class="navListBox">
        <div class="logoBox">
          <p class="logo">{{ systemName.value }}</p>
          <p class="name">全国中小企业融资综合信用服务平台&nbsp;&nbsp;岳阳站</p>
        </div>

        <div class="menuBox">
          <router-link :to="{name: 'index'}"><span class="cs2_nemu1">首页</span></router-link>
          <router-link :to="{name: 'financePro'}"><span class="cs2_nemu2">金融超市</span>
          </router-link>
          <router-link :to="{name: 'organization'}"><span class="cs2_nemu2">金融机构</span>
          </router-link>
          <router-link :to="{name: 'news'}"><span class="cs2_nemu2">资讯动态</span>
          </router-link>
<!--          <router-link :to="{name: 'fxts'}"><span class="cs2_nemu2">风险提示</span>
          </router-link>-->
          <router-link :to="{name: 'creditInquiry'}"><span class="cs2_nemu2">信用查询</span>
          </router-link>
          <a-popover placement="bottomLeft">
            <template slot="content">
              <div style="width: 80px;height: 30px;border-bottom: #cccccc 1px dashed" v-for="item in characteristicArea">
                <router-link tag="a" target="_blank" :to="{name:'financePro',query:{specialArea:item.param}}">
                  <span style="color: #333333;line-height: 30px">{{item.desc}}</span>
                </router-link>
              </div>
            </template>
            <span class="cs2_nemu2" >特色专区</span>
          </a-popover>
          <router-link :to="{name: 'questions'}"><span class="cs2_nemu2">常见问题</span>
          </router-link>
          <router-link :to="{name: 'introduce'}"><span class="cs2_nemu2">平台介绍</span>
          </router-link>
        </div>

        <div class="cs1_12_2" v-if="!this.$store.state.account.accountNonExpired">
          <span @mouseover="loginOver()"  @mouseleave="loginLeave()">登录</span>
          <span>&nbsp;&nbsp;|&nbsp;&nbsp;
            <a target="_blank" href="https://auth.zwfw.hunan.gov.cn/oauth2/register/register.html">注册</a>
<!--                          <router-link :to="{path: 'sm_registe2'}" target="_blank">注册</router-link>-->
                        </span>
          <div class="menu_sub" v-show="menuShow" @mouseover="loginOver()" @mouseleave="loginLeave()">
            <i class="uparrow"></i>
            <a class="nav-right-item" href="javascript:;" @click="info">中小企业登录</a>
<!--            <p><router-link :to="{path: 'loginCompany'}" target="_blank">中小企业登录</router-link></p>-->
            <router-link :to="{path: 'loginFinance'}" target="_blank">金融机构登录</router-link>
            <router-link :to="{name: 'Login'}" target="_blank">政府部门登录</router-link>
          </div>
        </div>
        <div class="cs1_12_3" v-if="this.$store.state.account.accountNonExpired">
          你好，
          {{ this.$store.state.account.name }}
          &nbsp;|&nbsp;
          <a class="nav-right-item" href="javascript:;" @click="goto">
            工作台
          </a>
          &nbsp;|&nbsp;
          <a class="nav-right-item" href="javascript:;" @click="out">
            退出
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {hnzw, loginOut} from "@/api/user";
import {getTypes} from '@/api/finance/finance';
import {mapGetters, mapState} from "vuex";

export default {
  name: 'myHead',
  computed: {
    ...mapState(["menuSourceList"]),
    ...mapGetters(["systemName", "storeAccount"])
  },
  data() {
    return {
      currentSort: 0,
      menuShow: false,
      characteristicArea: [],
    }
  },
  beforeRouteEnter(to, from, next){
    next(()=>{
      vm.initParams();
    })
  },
  created() {
    this.initParams();
  },
  methods: {
    // 登录切换事件
    loginOver(){
      this.menuShow = true;
    },
    loginLeave(){
      this.menuShow = false;
    },
    active(index) {
      this.currentSort = index;
    },
    goto() {
      if (this.menuSourceList[0].childMenuSourceList[0].systemMenu) {
        this.$router.push({
          name: this.menuSourceList[0].childMenuSourceList[0].code
        });
      } else {
        this.$router.push({
          path: '/crm/new/page/' + this.menuSourceList[0].childMenuSourceList[0].code,
          query: {id: this.menuSourceList[0].childMenuSourceList[0].id}
        });
      }
    },
    out() {

        loginOut().then(res => {
          this.$ajaxAfter(res).then(() => {

            if (this.storeAccount.roleId == 1025) {
              window.open("https://auth.zwfw.hunan.gov.cn/oauth2/logout?client_id=cp4zF99JSqG8YDD1wKjB4A&response_type=code&redirect_uri=http://credit.yueyang.gov.cn/xydapi/unifyLogin/syntony&flag=false", '_blank');
            }
              this.$router.push({
                  name: "index"
                });
                this.$store.commit("clearAccount");
          });
        });
    },
// 初始化特色专区参数
    initParams(){
      getTypes("003010")
          .then(res => {
            this.$ajaxAfter(res).then(() => {
              this.characteristicArea = res.data.data.list;
              this.$delete(this.characteristicArea,0);
            });
          })
          .catch(() => {
            this.$toast.fail("服务器出错！请稍后再试!");
          });
    },
    info() {
      // this.$info({
      //   content: (<div>长沙市金融综合服务平台面向全市中小微企业提供“信易贷”融资服务，请通过湖南政务服务网选择“<span style="color:red">企业</span>”账号进行登录。</div>),
      //   onOk() {
      window.location.href = "http://auth.zwfw.hunan.gov.cn/oauth2/authorize?client_id=cp4zF99JSqG8YDD1wKjB4A&response_type=gov&scope=user.read&redirect_uri=http://credit.yueyang.gov.cn/xydapi/unifyLogin/syntony";
      // this.$router.push({
      //   name: "LoginCompany",
      // });
      //   },
      // });
    }
  },
}
</script>

<style scoped lang="less">
.topMain{
  width: 100%;
  background-color: #ffffff;
  padding-bottom: 20px;
  box-shadow: 0px 0px 19px 1px rgba(143, 143, 143, 0.3);
  position: fixed;
  top: 0;
  z-index: 999;
}
.navListBox{
  width: 100%;
  min-width: 1300px;
  max-width: 1720px;
  margin: 0 auto;
  padding-top: 10px;
  position: relative;
}
@media screen and (max-width: 1850px) {
  .navListBox {
    padding: 20px 40px 0 40px;
  }
}
.logo {
  color: #333333;
  font-size: 40px;
  font-weight: 600;
  letter-spacing: 3px;

  span{
    display: inline-block;
    width: 45px;
    height: 51px;
    /*background: url("../../assets/img/logo2.svg") no-repeat center;*/
    background-size: 100% 100%;
    float: left;
    margin: 10px 10px 0 0;
  }
}
.logoBox{
  float: left;
  .name{
    color: #005BAA;
    font-size: 24px;
  }
}
.menuBox{
  float: left;
  margin-left: 80px;
  margin-top: 23px;
}
.cs2_nemu1 {
  font-family: "微软雅黑";
  font-size: 18px;
  text-decoration: none;
  line-height: 44px;
  height: 44px;
  color: #333333;
  padding-bottom: 10px;
  cursor: pointer;
}

.cs2_nemu2 {
  font-family: "微软雅黑";
  font-size: 18px;
  text-decoration: none;
  line-height: 44px;
  height: 44px;
  color: #333333;
  cursor: pointer;
  margin-left: 30px
}

.cs1_12_2 {
  color: #333333;
  font-size: 16px;
  padding-top: 10px;
  position: relative;
  display: flex;
  justify-content: space-around;
  float: right;

  .menu_sub{
    position: absolute;
    top: 50px;
    left: -50px;
    background: #ffffff;
    box-shadow: 0 6px 24px 4px rgba(143, 143, 143, 0.2);
    padding: 20px;
    line-height: 32px;
    border-radius: 4px;

    a{
      display: block;
      color: #333333;
      font-size: 15px;
    }

    i.uparrow {
      position: absolute;
      top: -20px;
      left: 44px;
      height: 22px;
      line-height: 22px;
      padding-right: 44px;
      font-size: 22px;
      background: url("../../assets/img/uparrow.png") no-repeat;
    }
  }
}

.cs1_12_2 a {
  color: #333333;
  font-size: 16px;
}

.cs1_12_3 {
  color: #333333;
  font-size: 16px;
  padding-top: 10px;
  position: absolute;
  display: flex;
  justify-content: space-around;
  right: 0px;
}

.cs1_12_3 a {
  color: #333333;
  font-size: 16px;
}
</style>
